module.exports = __webpack_public_path__ + "img/icon07.d4b234a5.png";